( function () {
	'use strict';

	function filterEvidence ( _ ) {
		return function ( arr, type ) {
			// type is string for evidences
			var evidenceType = {
				'Timer'   : 7,
				'Counter' : 6
			};

			if ( arr ) {
				if ( type === 'Script' ) {
					return _.filter( arr, 'type', 8 );
				}

				if ( type === 'Text' ) {
					// narrow the array to type 4
					var notes = _.filter( arr, 'type', 4 );

					return _.remove( notes, function ( val ) {
						// remove script evidences
						return val.timestamp === undefined;
					} );
				}

				return _.filter( arr, 'type', evidenceType[ type ] );
			}
		};
	}

	angular
		.module( 'app.components' )
		.filter( 'filterEvidence', filterEvidence );

	filterEvidence.$inject = [ '_' ];
} )( );
